module.exports = __webpack_public_path__ + "static/media/qurm_villas6.beec855e.webp";